import { render, staticRenderFns } from "./BxSwitch.vue?vue&type=template&id=6254a6de&"
import script from "./BxSwitch.vue?vue&type=script&lang=js&"
export * from "./BxSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports